import { Favorito } from 'src/contexto/types'

export const getFavoriteStoreKey = (
  favoritesStore: Favorito[],
  product_id: number,
  color?: string,
  voltage?: string
): number => {
  return favoritesStore.findIndex(
    (store) =>
      store.produto_id === product_id &&
      store.cor === color &&
      store.voltagem === voltage
  )
}
